import { render, staticRenderFns } from "./FontEdit.vue?vue&type=template&id=67a89225&scoped=true"
import script from "./FontEdit.vue?vue&type=script&lang=js"
export * from "./FontEdit.vue?vue&type=script&lang=js"
import style0 from "./FontEdit.vue?vue&type=style&index=0&id=67a89225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a89225",
  null
  
)

export default component.exports